import axios from 'axios';

import { API_BASE_URL } from 'utils/constants';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,

  headers: {
    'Content-Type': 'application/json',
  },
});

export const handlePostUserVisitsData = async (data) => {
  const response = await axiosInstance.post('/admin/users/getUsers', data);

  return response.data;
};

export const handleExportUserVisitsData = async (data) => {
  const response = await axiosInstance.post('/admin/users/export', data);

  return response.data;
};
